import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { User } from '../../../models/user.model';
import { Estudiante } from '../../../models/estudiante.model';
import { EstudianteService } from '../../../services/estudiante.service';

@Component({
  selector: 'app-usuario-card',
  templateUrl: './usuario-card.component.html',
  styleUrls: ['./usuario-card.component.css']
})
export class UsuarioCardComponent implements OnInit {
  @Input() user!: User;
  @Output() viewDetail = new EventEmitter<Estudiante>();
  
  estudiante: Estudiante | null = null;
  loadingEstudiante = false;
  errorLoadingEstudiante = false;

  constructor(private estudianteService: EstudianteService) {}

  ngOnInit(): void {
    if (this.user.nroLibreta) {
      this.loadEstudiante();
    }
  }

  getRoleDisplay(role: string): string {
    const roleMap: { [key: string]: string } = {
      'admin': 'Administrador',
      'mesa': 'Mesa de examen',
      'recepcion': 'Recepción',
      'readonly': 'Solo lectura'
    };
    return roleMap[role] || role;
  }

  getRoleClass(role: string): string {
    const classMap: { [key: string]: string } = {
      'admin': 'badge-danger',
      'mesa': 'badge-primary',
      'recepcion': 'badge-info',
      'readonly': 'badge-secondary'
    };
    return classMap[role] || 'badge-secondary';
  }

  private loadEstudiante(): void {
    if (!this.user.nroLibreta) return;

    this.loadingEstudiante = true;
    this.errorLoadingEstudiante = false;

    this.estudianteService.getEstudiante(this.user.nroLibreta).subscribe(
      estudiante => {
        this.estudiante = estudiante;
        this.loadingEstudiante = false;
      },
      error => {
        console.error('Error loading estudiante:', error);
        this.errorLoadingEstudiante = true;
        this.loadingEstudiante = false;
      }
    );
  }

  // Handle estudiante card view detail click - emit to parent
  onViewEstudianteDetail(estudiante: Estudiante): void {
    this.viewDetail.emit(estudiante);
  }

  formatDate(date: Date | string | undefined): string {
    if (!date) return 'N/A';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('es-AR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
}